<script>
import appConfig from '@/app.config'
import PageHeader from '@/components/page-header'
import Layout from '@/router/layouts/main'
import Swal from 'sweetalert2'
import Multiselect from 'vue-multiselect'
import { Helper } from '@/mixin/helper'
import { gmapApi } from 'vue2-google-maps'
import { required, maxLength } from 'vuelidate/lib/validators'
import moment from 'moment'

import {
  CREATE_ADDRESS,
  GET_CITIES,
  GET_DETAIL_ADDRESS,
  UPDATE_ADDRESS,
} from '@/services/api/master/address'
import { GET_ADDRESS } from '@/services/api/setting/general/address'

/**
 * Starter component
 */
export default {
  page: {
    title: 'Form Address',
    meta: [{ name: 'description', content: appConfig.description }],
  },
  components: {
    Layout,
    PageHeader,
    Multiselect,
  },
  mixins: [Helper],
  apollo: {
    citiesByCountry: {
      query: GET_CITIES,
    },
    geofence: {
      query: GET_DETAIL_ADDRESS,
      variables() {
        return {
          filter: {
            geofenceId: parseInt(this.id),
          },
        }
      },
      // Disable the query
      skip() {
        return this.$route.params.id === undefined
      },
      result({ data, loading }) {
        if (!loading) {
          this.geofence.geofence = data.geofence.geofence

          setTimeout(() => {
            this.initEditPage()
          }, 800)
        }
      },
    },
    addressCategories: {
      query: GET_ADDRESS,
      result({ data, loading }) {
        if (!loading) {
          const disabledCategory = ['Main Branch', 'Branch']
          this.categoryOptions = data.addressCategories.addressCategories.map((item) => item.text)

          for (let i = 0; i < disabledCategory.length; i++) {
            var myIndex = this.categoryOptions.indexOf(disabledCategory[i])
            if (myIndex !== -1) {
              this.categoryOptions.splice(myIndex, 1)
            }
          }
        }
      },
    },
  },
  data() {
    return {
      selected: [],
      selectedModel: [],
      allSelected: false,
      indeterminate: true,
      customer: {
        customer: [
          {
            customerId: 1,
            fullname: 'Superfood Group',
            email: 'admin_superfood@mceasy.cloud',
            companyCategories: 'Manufaktur',
            sales: 'Dimas Fariz',
            paymentTerms: 'Net 30',
            taxNo: '99.999.999.9-999.999',
          },
          {
            customerId: 2,
            fullname: 'PT Interior Bersama',
            email: 'interior.bersama@mceasy.cloud',
            companyCategories: 'Manufaktur',
            sales: 'Alfian Yudistira',
            paymentTerms: 'Net 60',
            taxNo: '99.999.999.9-999.999',
          },
          {
            customerId: 3,
            fullname: 'PT Medicarmasi',
            email: 'adm_medicarmasi@mceasy.cloud',
            companyCategories: 'Manufaktur',
            sales: 'Wilis Bagio',
            paymentTerms: 'Net 90',
            taxNo: '99.999.999.9-999.999',
          },
          {
            customerId: 4,
            fullname: 'Foodistri',
            email: 'foodistri@mceasy.cloud',
            companyCategories: 'Manufaktur',
            sales: 'Adi Tjandra',
            paymentTerms: 'Net 30',
            taxNo: '99.999.999.9-999.999',
          },
          {
            customerId: 5,
            fullname: 'Transportindo',
            email: 'log.transportindo@mceasy.cloud',
            companyCategories: 'Manufaktur',
            sales: 'Risman Satria',
            paymentTerms: 'Net 60',
            taxNo: '99.999.999.9-999.999',
          },
          {
            customerId: 6,
            fullname: 'PT Adi Jaya',
            email: 'admin_adijaya@mceasy.cloud',
            companyCategories: 'Manufaktur',
            sales: 'Dimas Fariz',
            paymentTerms: 'Net 90',
            taxNo: '99.999.999.9-999.999',
          },
        ],
      },
      fields: [
        {
          key: 'check',
        },
        {
          key: 'type',
          label: 'Type',
          tdClass: 'typeWidth',
        },
        {
          key: 'number',
          label: 'Number',
        },
        {
          key: 'expired',
          label: 'Expired',
        },
        {
          key: 'status',
          label: 'Status',
        },
      ],
      tData: [],
      citiesByCountry: {
        citiesByCountry: [],
      },
      addressCategories: {
        addressCategories: [],
      },
      categoryOptions: [],
      isEdit: false,

      form: {
        customerId: null,
        customer_name: null,
        sector: null,
        location_name: null,
        address: null,
        province: null,
        city: null,
        postal_code: null,
        contact_person: null,
        phone_no: null,
        radius: 100,
        latitude: '',
        longitude: '',
        serviceStart: null,
        serviceEnd: null,
        breakStart: null,
        breakEnd: null,
        circle_data: [],
        poly_data: [],
        address_detail: '',
        latLang: '',
        is_garage: false,
        is_service: false,
        is_billingAddr: false,
        is_depot: false,
        service_location: '',
      },
      geofence: {
        geofence: {},
      },
      loading: false,
      poly_error: false,
      circle_error: false,
      searchLocation: null,
      map_radio: 'circle',
      map: null,
      circle: null,
      polygon: null,
      places: [],
      id: this.$route.params.id || 0,
      isFormDisabled: false,
    }
  },
  validations: {
    form: {
      sector: { required },
      location_name: { required, maxLength: maxLength(60) },
      address: { required },
      province: { required },
      city: { required },
      latLang: { required },
      phone_no: { maxLength: maxLength(15) },
      contact_person: { maxLength: maxLength(60) },
    },
  },
  computed: {
    google: gmapApi,
    title() {
      return this.$route.params.id === undefined ? this.$t('master.form.address.addAddress') : this.$t('master.form.address.updateAddress')
    },
    items() {
      return [
        {
          text: this.$t('menuitems.masterData.text'),
        },
        {
          text: this.$t('menuitems.masterData.list.address'),
          href: '/master/address',
        },
        {
          text: this.$route.params.id === undefined ? this.$t('master.form.address.addAddress') : this.form.location_name,
          active: true,
        },
      ]
    },
    provinces() {
      var provinces = this.citiesByCountry.citiesByCountry.map(function (item) {
        return item.province
      })

      return [...new Set(provinces)].sort()
    },
    cities() {
      if (this.form.province === null || this.form.province === '') {
        return []
      }

      var province = this.form.province
      var cities = this.citiesByCountry.citiesByCountry
        .filter(function (item) {
          return item.province == province
        })
        .map((field) => field.city)

      return cities
    },
    oldData() {
      if (this.geofence.geofence !== undefined) {
        var old = this.geofence.geofence
        if (this.map_radio == 'circle') {
          var latLang = []
          if (this.geofence.geofence.circData !== null) {
            var circData = this.geofence.geofence.circData.replace('<', '').replace('>', '')
            var circleArray = circData.split('),')
            old.radius = circleArray[1]
            latLang = circleArray[0].replace('(', '').split(',')
          }
          old.circle_data = latLang
          old.poly_data = []
        } else {
          var newPoly = []
          if (this.geofence.geofence.polyData !== null) {
            var polyData = this.geofence.geofence.polyData
            var polyArray = polyData.split('),')
            polyArray.forEach(function (item) {
              newPoly.push(item.replaceAll('(', '').replaceAll(')', '').split(','))
            })
          }
          old.poly_data = newPoly
          old.circle_data = []
          old.radius = null
        }
        return old
      }

      return {}
    },
  },
  created() {
    for (let i = 0; i < this.tData.length; i++) {
      this.selectedModel.push(false)
    }
  },
  async mounted() {
    const self = this

    await this.$refs.MapAddress.$mapPromise.then((map) => {
      self.map = map
    })

    setTimeout(() => {
      var input = document.getElementById('search-address')

      const searchBox = new this.google.maps.places.SearchBox(input)

      // Bias the SearchBox results towards current map's viewport.
      this.map.addListener('bounds_changed', () => {
        searchBox.setBounds(this.map.getBounds())
      })

      // Listen for the event fired when the user selects a prediction and retrieve
      // more details for that place.
      searchBox.addListener('places_changed', () => {
        this.isEdit = false
        const places = searchBox.getPlaces()
        this.places = places
        if (places.length == 0) {
          return
        }

        if (this.map_radio === 'circle') {
          this.initMapCircle(places)
        } else if (this.map_radio === 'polygon') {
          this.initMapPoly(places)
        }
      })
    }, 200)
  },
  watch: {
    selected(newValue) {
      // Handle changes in individual flavour checkboxes
      if (newValue.length === 0) {
        this.indeterminate = false
        this.allSelected = false
      } else if (newValue.length == this.tData.length) {
        this.indeterminate = false
        this.allSelected = true
      } else {
        this.indeterminate = true
        this.allSelected = false
      }
    },
  },
  methods: {
    initEditPage() {
      this.isEdit = true
      this.form.customerId = this.geofence.geofence.customerId
      this.form.location_name = this.geofence.geofence.fenceName
      this.form.address = this.geofence.geofence.address
      this.form.address_detail = this.geofence.geofence.addressDetail
      this.form.province = this.geofence.geofence.province
      this.form.city = this.geofence.geofence.city
      this.form.postal_code = this.geofence.geofence.postalCode
      this.form.sector = this.geofence.geofence.category
      this.form.contact_person = this.geofence.geofence.contactName
      this.form.phone_no = this.geofence.geofence.phoneNo
      this.form.is_garage = this.geofence.geofence.isGarage
      this.form.is_service = this.geofence.geofence.isServiceLoc
      this.form.is_billingAddr = this.geofence.geofence.isBillingAddr
      this.form.is_depot = this.geofence.geofence.isDepot
      this.form.serviceStart = this.geofence.geofence.serviceStart
      this.form.serviceEnd = this.geofence.geofence.serviceEnd
      this.form.breakStart = this.geofence.geofence.breakStart
      this.form.breakEnd = this.geofence.geofence.breakEnd
      this.form.service_location = this.geofence.geofence.serviceLocType

      this.map_radio = this.geofence.geofence.type == 'C' ? 'circle' : 'polygon'

      if (this.map_radio == 'circle') {
        var circData = this.geofence.geofence.circData.replace('<', '').replace('>', '')
        var circleArray = circData.split('),')
        this.form.radius = circleArray[1]
        this.form.latLang = circleArray[0] + ')'
        var latLang = circleArray[0].replace('(', '').split(',')

        this.form.circle_data = latLang

        this.map.panTo({
          lat: parseFloat(latLang[0]),
          lng: parseFloat(latLang[1]),
        })
        this.form.latitude = latLang[0]
        this.form.longitude = latLang[1]
        this.map.setZoom(17)

        this.initMapCircle()
      } else {
        var polyData = this.geofence.geofence.polyData
        this.form.latLang = polyData.slice(1, -1)
        this.form.radius = null
        var polyArray = polyData.split('),')
        var newPoly = []
        polyArray.forEach(function (item) {
          newPoly.push(item.replaceAll('(', '').replaceAll(')', '').split(','))
        })

        this.form.poly_data = newPoly
        this.initMapPoly()
      }
      this.checkDisableForm()
    },
    initMapCircle(places) {
      if (this.circle != null) {
        this.circle.setMap(null)
        this.circle = null
      }

      this.circle = new this.google.maps.Circle({
        strokeColor: '#0D4491',
        strokeOpacity: 0.8,
        strokeWeight: 2,
        fillColor: '#1C74DA',
        fillOpacity: 0.35,
        map: this.map,
        radius: parseInt(this.form.radius),
        editable: true,
        draggable: true,
      })
      var circle = this.circle

      this.circle.setMap(null)
      this.circle.setMap(this.map)

      if (places === undefined) {
        this.circle.setCenter({
          lat: parseFloat(this.form.latitude),
          lng: parseFloat(this.form.longitude),
        })
      } else {
        this.circle.setCenter(places[0].geometry.location)
      }

      this.map.fitBounds(this.circle.getBounds())

      this.google.maps.event.addListener(circle, 'center_changed', () => {
        this.updateCircleCoordsState(circle)
      })

      this.google.maps.event.addListener(circle, 'radius_changed', () => {
        this.updateCircleCoordsState(circle)
      })
    },
    initMapPoly(places) {
      if (this.polygon != null) {
        this.polygon.setMap(null)
        this.polygon = null
      }

      var Coords = []
      if (places !== undefined) {
        Coords = [
          {
            lat: places[0].geometry.location.lat() - 1 / 1000,
            lng: places[0].geometry.location.lng() + 1 / 1000,
          },
          {
            lat: places[0].geometry.location.lat() - 1 / 1000,
            lng: places[0].geometry.location.lng() - 1 / 1000,
          },
          {
            lat: places[0].geometry.location.lat() + 1 / 1000,
            lng: places[0].geometry.location.lng() - 1 / 1000,
          },
          {
            lat: places[0].geometry.location.lat() + 1 / 1000,
            lng: places[0].geometry.location.lng() + 1 / 1000,
          },
        ]
      } else {
        this.form.poly_data.forEach(function (item) {
          Coords.push({
            lat: parseFloat(item[0]),
            lng: parseFloat(item[1]),
          })
        })
      }

      // Construct the polygon.
      this.polygon = new this.google.maps.Polygon({
        paths: Coords,
        strokeColor: '#0D4491',
        strokeOpacity: 0.8,
        strokeWeight: 2,
        fillColor: '#1C74DA',
        fillOpacity: 0.35,
        editable: true,
        draggable: true,
      })
      this.polygon.setMap(null)
      this.polygon.setMap(this.map)

      const bounds = new this.google.maps.LatLngBounds()

      if (places !== undefined) {
        if (places[0].geometry.viewport) {
          bounds.union(places[0].geometry.viewport)
        } else {
          bounds.extend(places[0].geometry.location)
        }

        this.map.fitBounds(bounds)
      } else {
        this.map.panTo({
          lat: parseFloat(this.form.poly_data[0][0]),
          lng: parseFloat(this.form.poly_data[0][1]),
        })

        this.map.setZoom(16)
      }

      this.polygon.getPaths().forEach((path) => {
        this.google.maps.event.addListener(path, 'insert_at', () => {
          this.updatePolygonCoordsState(path)
        })

        this.google.maps.event.addListener(path, 'remove_at', () => {
          this.updatePolygonCoordsState(path)
        })

        this.google.maps.event.addListener(path, 'set_at', () => {
          this.updatePolygonCoordsState(path)
        })
      })
    },
    async getLocation() {
      if (this.map_radio === 'circle') {
        if (this.circle == null) return

        this.form.latitude = this.circle.center.lat()
        this.form.longitude = this.circle.center.lng()
        this.form.radius = this.circle.getRadius()

        this.form.circle_data = [this.form.latitude, this.form.longitude]
        this.form.latLang = '(' + this.form.latitude + ', ' + this.form.longitude + ')'
      } else if (this.map_radio === 'polygon') {
        if (this.polygon == null) return

        var latLang = []
        for (var i = 0; i < this.polygon.getPath().getLength(); i++) {
          var koma = ''
          if (this.polygon.getPath().getLength() - 1 != i) {
            koma = ','
          }

          var lat = parseFloat(this.polygon.getPath().getAt(i).lat()).toFixed(8)
          var lang = parseFloat(this.polygon.getPath().getAt(i).lng()).toFixed(8)
          this.form.latitude += lat + koma
          this.form.longitude += lang + koma

          this.form.poly_data.push([lat, lang])
          latLang.push('(' + lat + ', ' + lang + ')')
        }

        this.form.latLang = latLang.join(', ')
      }

      const places = this.places

      this.getPlace(places)
    },
    async getPlace(places) {
      const str_remove = ['Kota ', 'Kabupaten ', ' City']
      for (let i = 0; i < places.length; i++) {
        this.form.address = places[i].formatted_address
        this.form.province = null
        this.form.city = null

        const city_index = this.places[i].address_components.findIndex(
          (i) => i.types[0] === 'administrative_area_level_2'
        )
        const province_index = this.places[i].address_components.findIndex(
          (i) => i.types[0] === 'administrative_area_level_1'
        )
        if (province_index !== -1) {
          this.form.province = places[i].address_components[province_index].long_name
          //   if (navigator.language == 'id') this.form.province = places[i].address_components[province_index].long_name
          //   else this.form.province = this.$i18n.t(`state.${places[i].address_components[province_index].long_name}`);
        }
        if (city_index !== -1) {
          let city_name = places[i].address_components[city_index].long_name
          for (let idx = 0; idx < str_remove.length; idx++) {
            city_name = city_name.replace(str_remove[idx], '')
          }
          this.form.city = city_name
        }
      }
    },
    changeGeoType(item) {
      if (this.circle != null) {
        this.circle.setMap(null)
        this.circle = null
        this.circle_error = false
        this.form.circle_data = []
        this.form.latLang = ''
      } else if (this.polygon != null) {
        this.polygon.setMap(null)
        this.polygon = null
        this.poly_error = false
        this.form.poly_data = []
        this.form.latLang = ''
      }

      if (item == 'polygon') {
        this.form.radius = null
      } else if (item == 'circle') {
        this.form.radius = 100
      }
      if (this.places && this.places.length > 0) {
        if (item === 'circle') {
          this.initMapCircle(this.places)

          this.form.latitude = this.circle.center.lat()
          this.form.longitude = this.circle.center.lng()
          this.form.radius = this.circle.getRadius()

          this.form.circle_data = [this.form.latitude, this.form.longitude]
          this.form.latLang = '(' + this.form.latitude + ', ' + this.form.longitude + ')'
        } else if (item === 'polygon') {
          this.initMapPoly(this.places)

          var latLang = []
          for (var i = 0; i < this.polygon.getPath().getLength(); i++) {
            var koma = ''
            if (this.polygon.getPath().getLength() - 1 != i) {
              koma = ','
            }

            var lat = parseFloat(this.polygon.getPath().getAt(i).lat()).toFixed(8)
            var lang = parseFloat(this.polygon.getPath().getAt(i).lng()).toFixed(8)
            this.form.latitude += lat + koma
            this.form.longitude += lang + koma

            this.form.poly_data.push([lat, lang])
            latLang.push('(' + lat + ', ' + lang + ')')
          }

          this.form.latLang = latLang.join(', ')
          this.form.radius = null
          const bounds = new this.google.maps.LatLngBounds()
          if (this.places[0].geometry.viewport) {
            bounds.union(this.places[0].geometry.viewport)
          } else {
            bounds.extend(this.places[0].geometry.location)
          }
          this.map.fitBounds(bounds)
        }
      }
    },
    setLocation() {
      setTimeout(() => {
        this.getLocation()
      }, 1200)
    },
    setRadius() {
      setTimeout(() => {
        if (this.circle != null && this.form.radius) {
          this.circle.setRadius(parseInt(this.form.radius))
          this.map.fitBounds(this.circle.getBounds())
        }
      }, 200)
    },
    deleteVector() {
      if (this.circle != null) {
        this.circle.setMap(null)
        this.circle = null
        this.form.radius = 100
      } else if (this.polygon != null) {
        this.polygon.setMap(null)
        this.polygon = null
        this.form.radius = null
      }

      this.form.address = null
      this.form.province = null
      this.form.city = null
      this.form.postal_code = null
      this.form.latitude = null
      this.form.longitude = null
      this.form.latLang = null
      this.form.circle_data = null
      this.form.poly_data = null
      this.places = null
    },
    submitForm() {
      // stop here if form is invalid
      this.$v.$touch()
    },
    toggleAll(checked) {
      this.selectedModel = []
      this.selected = []
      if (checked) {
        for (let i = 0; i < this.tData.length; i++) {
          this.selected.push(i)
          this.selectedModel.push(true)
        }
      } else {
        for (let i = 0; i < this.tData.length; i++) {
          this.selectedModel.push(false)
        }
        this.selected = []
      }
    },
    checkTable(event, data) {
      if (event) {
        this.selected.push(data.index)
      } else {
        var myIndex = this.selected.indexOf(data.index)
        if (myIndex !== -1) {
          this.selected.splice(myIndex, 1)
        }
      }
    },
    addDocumentPermit() {
      this.tData.push({
        type: null,
        number: null,
        expired: null,
        status: null,
      })
    },
    checkStatus(index) {
      const today = new Date()
      const zeroPad = (num, places) => String(num).padStart(places, '0')
      const date =
        today.getFullYear() + '-' + zeroPad(today.getMonth() + 1, 2) + '-' + today.getDate()
      if (date >= this.tData[index].expired) {
        this.tData[index].status = 'expired'
      } else {
        var range = this.getDatesInRange(date, this.tData[index].expired).length
        if (range <= 30) {
          this.tData[index].status = 'near'
        } else {
          this.tData[index].status = 'active'
        }
      }
    },
    getDatesInRange(startDate, endDate) {
      startDate = new Date(startDate)
      endDate = new Date(endDate)
      const date = new Date(startDate.getTime())

      const dates = []

      while (date <= endDate) {
        dates.push(new Date(date))
        date.setDate(date.getDate() + 1)
      }

      return dates
    },
    onChangeNumber() {
      let text = this.form.phone_no
      const conditions = ['1', '2', '3', '4', '5', '6', '7', '8', '9', '0', '(', ')', '-']
      for (let i = 0; i < text.length; i++) {
        var state = false
        for (let j = 0; j < conditions.length; j++) {
          if (conditions[j] == text[i]) {
            state = true
            break
          }
        }
        if (state == false) {
          this.form.phone_no = null
          break
        }
      }
    },
    toDelete() {
      this.selected.sort()
      this.selected.reverse()
      this.selected.forEach((row) => {
        this.$delete(this.tData, row)
      })
      this.selected = []
      this.selectedModel = []

      this.indeterminate = false
      this.allSelected = false
      for (let i = 0; i < this.tData.length; i++) {
        this.selectedModel.push(false)
      }
    },
    checkEmpty() {
      var isEmpty = true
      var forms = this.form
      var excepts = ['poly_data', 'circle_data', 'is_garage', 'radius']
      Object.keys(this.form).forEach(function (key) {
        if (forms[key] != null && forms[key] != '') {
          if (typeof forms[key] !== 'object') {
            if (!excepts.includes(key)) {
              isEmpty = false
            }
          } else {
            if (!excepts.includes(key)) {
              Object.keys(forms[key]).forEach(function (subKey) {
                if (forms[key][subKey] != null && forms[key][subKey] != '') {
                  isEmpty = false
                }
              })
            }
          }
        }
      })

      return isEmpty
    },
    checkChanged() {
      var isChanged = false
      var forms = this.form
      var formOld = this.oldData
      var excepts = ['latLang', 'longitude', 'latitude']
      var formField = {
        customerId: 'customerId',
        sector: 'category',
        location_name: 'fenceName',
        address: 'address',
        province: 'province',
        city: 'city',
        postal_code: 'postalCode',
        contact_person: 'contactName',
        phone_no: 'phoneNo',
        radius: 'radius',
        latitude: 'latitude',
        longitude: 'longitude',
        serviceStart: 'serviceStart',
        serviceEnd: 'serviceEnd',
        breakStart: 'breakStart',
        breakEnd: 'breakEnd',
        circle_data: 'circle_data',
        poly_data: 'poly_data',
        address_detail: 'addressDetail',
        is_garage: 'isGarage',
        is_service: 'isServiceLoc',
        is_billingAddr: 'isBillingAddr',
        is_depot: 'isDepot',
        service_location: 'serviceLocType',
      }
      Object.keys(this.form).forEach(function (key) {
        if (!excepts.includes(key)) {
          if (forms[key] != formOld[formField[key]]) {
            if (key == 'circle_data') {
              if (JSON.stringify(forms[key]) != JSON.stringify(formOld[formField[key]])) {
                isChanged = true
              }
            } else if (key == 'poly_data') {
              if (JSON.stringify(forms[key]) != JSON.stringify(formOld[formField[key]])) {
                isChanged = true
              }
            } else {
              isChanged = true
            }
          }
        }
      })

      return isChanged
    },
    toCancel() {
      var isEmpty = this.checkEmpty()
      if (this.$route.params.id) {
        isEmpty = !this.checkChanged()
      }
      if (isEmpty) {
        this.$router.push('/master/address')
      } else {
        Swal.fire({
          title: 'Batalkan',
          text: 'Anda yakin akan membatalkan',
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#f46a6a',
          cancelButtonColor: '#34c38f',
          confirmButtonText: 'Ya',
          cancelButtonText: 'Tidak',
        }).then((result) => {
          if (result.value) {
            this.$router.push('/master/address')
          }
        })
      }
    },
    updatePolygonCoordsState(poly) {
      this.form.poly_data = []

      var latLang = []
      for (var i = 0; i < poly.getLength(); i++) {
        var koma = ''
        if (poly.getLength() - 1 != i) {
          koma = ','
        }

        var lat = parseFloat(poly.getAt(i).lat()).toFixed(8)
        var lang = parseFloat(poly.getAt(i).lng()).toFixed(8)
        this.form.latitude += lat + koma
        this.form.longitude += lang + koma

        this.form.poly_data.push([lat, lang])
        latLang.push('(' + lat + ', ' + lang + ')')
      }

      this.form.latLang = latLang.join(', ')
    },
    updateCircleCoordsState(circle) {
      this.form.latitude = circle.center.lat()
      this.form.longitude = circle.center.lng()
      this.form.radius = circle.getRadius()

      this.form.circle_data = [this.form.latitude, this.form.longitude]
      this.form.latLang = '(' + this.form.latitude + ', ' + this.form.longitude + ')'
    },
    changeProvince() {
      this.form.city = null
    },
    checkGarage() {
      this.$v.$touch()
      if (this.$v.$error) {
        return
      }
      if (this.$route.params.id === undefined) return this.toSave()
      var isGarage = this.form.is_garage
      var oldGarage = this.oldData.isGarage
      if (oldGarage === true) {
        if (isGarage === false) {
          this.$bvModal.show('modal-change-data')
          return
        }
      }
      this.toSave()
    },
    toSave() {
      var form = this.convertNewData()
      if (this.id !== undefined && this.id != 0) {
        var type = this.oldData.type == 'C' ? 'circle' : 'polygon'
        var oldData = {
          customerId: this.oldData.customerId,
          circData: this.oldData.circData,
          polyData: this.oldData.polyData,
          fenceName: this.oldData.fenceName,
          type: type,
          address: this.oldData.address,
          addressDetail: this.oldData.addressDetail,
          province: this.oldData.province,
          city: this.oldData.city,
          postalCode: this.oldData.postalCode,
          category: this.oldData.category,
          contactName: this.oldData.contactName,
          phoneNo: this.oldData.phoneNo,
          isGarage: this.oldData.isGarage,
          isServiceLoc: this.oldData.isServiceLoc,
          isBillingAddr: this.oldData.isBillingAddr,
          isDepot: this.oldData.isDepot,
          serviceStart: this.oldData.serviceStart,
          serviceEnd: this.oldData.serviceEnd,
          breakStart: this.oldData.breakStart,
          breakEnd: this.oldData.breakEnd,
          serviceLocType: this.oldData.serviceLocType,
        }

        this.$apollo
          .mutate({
            mutation: UPDATE_ADDRESS,
            variables: {
              input: {
                geofenceId: parseInt(this.id),
                oldData: oldData,
                newData: form,
              },
            },
          })
          .then((response) => {
            if (response.data.updateGeofence.isSuccessful) {
              this.$apollo.queries.geofence.refetch()
              this.$toast.success(`Data Alamat berhasil tersimpan`)
              this.$bvModal.hide('modal-change-data')

              setTimeout(() => {
                this.$router.push({ name: 'Master Address' })
              }, 1000)
            } else {
              if (response.data.updateGeofence.message == 'Error: "geofence name was exist"') {
                return this.$toast.error('Nama Lokasi Sudah digunakan')
              } else {
                return this.$toast.error(response.data.updateGeofence.message)
              }
            }
          })
      } else {
        this.$apollo
          .mutate({
            mutation: CREATE_ADDRESS,
            variables: {
              input: form,
            },
          })
          .then((response) => {
            if (response.data.createGeofence.isSuccessful) {
              this.$apollo.queries.geofence.refetch()
              this.$toast.success(`Data Alamat berhasil tersimpan`)
              this.$bvModal.hide('modal-change-data')

              setTimeout(() => {
                this.$router.push({ name: 'Master Address' })
              }, 1000)
            } else {
              if (response.data.createGeofence.message == 'Error: "geofence name was exist"') {
                return this.$toast.error('Nama Lokasi Sudah digunakan')
              } else {
                return this.$toast.error(response.data.createGeofence.message)
              }
            }
          })
      }
    },
    convertNewData() {
      var latLangData = {}
      var type = null
      var circleData = '<' + this.form.latLang + ',' + this.form.radius + '>'
      var polyData = this.form.latLang

      if (this.map_radio == 'circle') {
        latLangData = {
          circData: circleData,
          polyData: null,
        }
        type = 'circle'
      } else if (this.map_radio == 'polygon') {
        latLangData = {
          polyData: polyData,
          circData: null,
        }
        type = 'polygon'
      }

      var form = {
        ...latLangData,
        fenceName: this.form.location_name,
        customerId: this.form.customerId,
        type: type,
        address: this.form.address,
        addressDetail: this.form.address_detail,
        province: this.form.province,
        city: this.form.city,
        postalCode: this.form.postal_code,
        category: this.form.sector,
        contactName: this.form.contact_person,
        phoneNo: this.form.phone_no,
        isGarage: this.form.is_garage,
        isServiceLoc: this.form.is_service,
        isBillingAddr: this.form.is_billingAddr,
        isDepot: this.form.is_depot,
        serviceStart: moment(this.form.serviceStart, 'HH:mm').format('HH:mm:ss'),
        serviceEnd: moment(this.form.serviceEnd, 'HH:mm').format('HH:mm:ss'),
        breakStart: moment(this.form.breakStart, 'HH:mm').format('HH:mm:ss'),
        breakEnd: moment(this.form.breakEnd, 'HH:mm').format('HH:mm:ss'),
        serviceLocType: this.form.service_location,
      }

      return form
    },
    checkDisableForm() {
      if (
        this.geofence.geofence.category == 'Main Branch' ||
        this.geofence.geofence.category == 'Branch'
      ) {
        this.isFormDisabled = true
      }
    },
  },
}
</script>

<template>
  <Layout>
    <div class="mc-list-header">
      <PageHeader :title="title" :items="items" class="mc-page-three" />

      <div class="clearfix mc-btn-group__list mc-btn-group__list--detail">
        <div class="float-end">
          <b-button class="mx-2" variant="outline-primary" @click="toCancel">
            <i class="mc-fa icon-fill_close"></i> {{ $t('global.cancel') }}
          </b-button>
          <b-button variant="primary" @click="checkGarage" v-if="!isFormDisabled">
            <i class="mc-fa icon-outline_save"></i> {{ $t('global.save') }}
          </b-button>
        </div>
      </div>
    </div>

    <form class="needs-validation mc-form mc-form--address" @submit.prevent="submitForm">
      <b-row>
        <b-col sm="12" md="7">
          <b-card>
            <b-row class="mc-form--address-search mb-2">
              <b-col md="10">
                <b-form-input
                  id="search-address"
                  :placeholder="$t('master.form.address.searchLocation')"
                  v-model="searchLocation"
                  trim
                  autocomplete="off"
                  :disabled="isFormDisabled"
                  @change="setLocation"
                ></b-form-input>
              </b-col>
              <b-col md="2">
                <b-button class="mc-btn--block" variant="primary" @click="getLocation">
                  {{ $t('global.search') }}
                </b-button>
              </b-col>
              <!-- TODO: disabled button on map background color still same as not disabled button -->
              <b-col md="12">
                <div class="mc-map-address-icon">
                  <a name="delete-form" id="eraser" value="eraser" @click="deleteVector">
                    <label for="eraser">
                      <i class="fas fa-eraser"></i>
                    </label>
                  </a>

                  <span>
                    <input
                      type="radio"
                      name="map-radio"
                      id="polygon"
                      value="polygon"
                      v-model="map_radio"
                      :disabled="isEdit"
                      @input="changeGeoType('polygon')"
                    />
                    <label for="polygon">
                      <i class="fas fa-draw-polygon"></i>
                    </label>
                  </span>

                  <span>
                    <input
                      type="radio"
                      name="map-radio"
                      id="circle"
                      value="circle"
                      v-model="map_radio"
                      :disabled="isEdit"
                      @input="changeGeoType('circle')"
                    />
                    <label for="circle">
                      <i class="fas fa-circle"></i>
                    </label>
                  </span>
                </div>
                <GmapMap
                  id="map"
                  ref="MapAddress"
                  :center="$store.state.map.center"
                  :zoom="parseFloat($store.state.map.zoom)"
                  class="mc-map-address mt-2"
                ></GmapMap>
              </b-col>
            </b-row>
          </b-card>
        </b-col>

        <b-col sm="12" md="5">
          <b-card>
            <b-row>
              <h4 class="card-title mb-4">{{ $t('master.form.address.addressInfo') }}</h4>
              <b-col md="6" sm="12">
                <div class="mb-3">
                  <b-form-group
                    id="customer_name_label"
                    :label="$t('master.form.address.name')"
                    label-for="customer_name"
                    label-class="required"
                  >
                    <b-form-input
                      id="location_name"
                      v-model="form.location_name"
                      :placeholder="`${$t('global.form.enter')} ${$t('master.form.address.name')}`"
                      type="text"
                      :disabled="isFormDisabled"
                      :class="{
                        'is-invalid': $v.form.location_name.$error,
                      }"
                    ></b-form-input>
                    <div v-if="$v.form.location_name.$error" class="invalid-feedback">
                      <span v-if="!$v.form.location_name.required">
                        {{ $t('master.address.form.name') }}
                        {{ $t('global.validation.required') }}
                      </span>
                      <span v-if="!$v.form.location_name.maxLength">{{
                        $t('master.address.form.maxLocationName')
                      }}</span>
                    </div>
                  </b-form-group>
                </div>
              </b-col>

              <b-col md="6" sm="12">
                <div class="mb-3">
                  <b-form-group
                    id="sector_label"
                    :label="$t('master.form.address.addressCategory')"
                    label-for="sector"
                    label-class="required"
                  >
                    <multiselect
                      v-model="form.sector"
                      :placeholder="`${$t('global.form.select')} ${$t('master.form.address.addressCategory')}`"
                      :class="{
                        'is-invalid': $v.form.sector.$error,
                      }"
                      :options="categoryOptions"
                      :disabled="isFormDisabled"
                    ></multiselect>
                    <div v-if="$v.form.sector.$error" class="invalid-feedback">
                      <span v-if="!$v.form.sector.required">
                        {{ $t('master.address.form.addressCategory') }}
                        {{ $t('global.validation.required') }}
                      </span>
                    </div>
                  </b-form-group>
                </div>
              </b-col>

              <b-col
                md="12"
                sm="12"
                v-if="
                  $store.state.access.data.md1['md1-c1'].read &&
                  $store.state.masterAddress.status == 'customer'
                "
              >
                <div class="mb-3">
                  <b-form-group
                    id="customer_label"
                    label="Nama Pelanggan"
                    label-for="customer"
                    label-class="required"
                  >
                    <template v-if="isFormDisabled">
                      <multiselect
                        v-model="form.temp"
                        placeholder="Pilih Nama Pelanggan"
                        :options="customer.customer"
                        :disabled="isFormDisabled"
                        :value="customer.customer.customerId"
                        track-by="fullname"
                        label="fullname"
                      ></multiselect>
                    </template>
                    <template v-else>
                      <multiselect
                        v-model="form.temp"
                        placeholder="Pilih Nama Pelanggan"
                        :options="customer.customer"
                        :disabled="isEdit"
                        :value="customer.customer.customerId"
                        track-by="fullname"
                        label="fullname"
                      ></multiselect>
                    </template>
                  </b-form-group>
                </div>
              </b-col>

              <b-col md="12" sm="12">
                <div class="mb-3">
                  <b-form-group
                    id="address_label"
                    :label="$t('master.form.address.fullAddress')"
                    label-for="address"
                    label-class="required"
                  >
                    <b-form-textarea
                      id="address"
                      v-model="form.address"
                      :disabled="isFormDisabled"
                      :placeholder="`${$t('global.form.enter')} ${$t('master.form.address.fullAddress')}`"
                      rows="3"
                      :class="{
                        'is-invalid': $v.form.address.$error,
                      }"
                      max-rows="6"
                    ></b-form-textarea>
                    <div v-if="$v.form.address.$error" class="invalid-feedback">
                      <span v-if="!$v.form.address.required">
                        {{ $t('master.address.form.fullAddress') }}
                        {{ $t('global.validation.required') }}
                      </span>
                    </div>
                  </b-form-group>
                </div>
              </b-col>
              <!-- Province -->
              <b-col md="6" sm="12">
                <div class="mb-3">
                  <b-form-group
                    id="province_label"
                    :label="$t('master.form.address.province')"
                    label-for="province"
                    label-class="required"
                  >
                    <multiselect
                      v-model="form.province"
                      :placeholder="`${$t('global.form.select')} ${$t(
                        'master.form.address.province'
                      )}`"
                      :options="provinces"
                      :class="{
                        'is-invalid': $v.form.province.$error,
                      }"
                      @input="changeProvince"
                      :disabled="isFormDisabled"
                    ></multiselect>
                    <div v-if="$v.form.province.$error" class="invalid-feedback">
                      <span v-if="!$v.form.province.required">
                        {{ $t('master.form.address.province') }}
                        {{ $t('global.validation.required') }}
                      </span>
                    </div>
                  </b-form-group>
                </div>
              </b-col>
              <!-- City -->
              <b-col md="6" sm="12">
                <div class="mb-3">
                  <b-form-group
                    id="city_label"
                    :label="$t('master.form.address.city')"
                    label-for="city"
                    label-class="required"
                  >
                    <multiselect
                      v-model="form.city"
                      :placeholder="`${$t('global.form.select')} ${$t('master.form.address.city')}`"
                      :options="cities"
                      :class="{
                        'is-invalid': $v.form.city.$error,
                      }"
                      :disabled="isFormDisabled"
                    ></multiselect>
                    <div v-if="$v.form.city.$error" class="invalid-feedback">
                      <span v-if="!$v.form.city.required">
                        {{ $t('master.form.address.city') }}
                        {{ $t('global.validation.required') }}
                      </span>
                    </div>
                  </b-form-group>
                </div>
              </b-col>

              <b-col md="12" sm="12">
                <div class="mb-3">
                  <b-form-group
                    id="circle_data_label"
                    :label="$t('master.form.address.latLong')"
                    label-for="circle_data"
                    v-if="map_radio == 'circle'"
                    label-class="required"
                  >
                    <b-form-input
                      id="circle_data"
                      :placeholder="`${$t('global.form.enter')} ${$t('master.form.address.latLong')}`"
                      v-model="form.latLang"
                      :disabled="isFormDisabled"
                      trim
                      :class="{
                        'is-invalid': $v.form.latLang.$error,
                      }"
                    ></b-form-input>
                    <div v-if="$v.form.latLang.$error" class="invalid-feedback">
                      <span v-if="$v.form.latLang.$error">
                        {{ $t('master.address.form.latLong') }}
                        {{ $t('global.validation.required') }}
                      </span>
                    </div>
                  </b-form-group>

                  <b-form-group
                    id="poly_data_label"
                    label="Garis Lintang & Bujur"
                    label-for="poly_data"
                    v-if="map_radio == 'polygon'"
                    label-class="required"
                  >
                    <b-form-input
                      id="poly_data"
                      placeholder="Garis Lintang & Bujur"
                      v-model="form.latLang"
                      :disabled="isFormDisabled"
                      trim
                      :class="{
                        'is-invalid': $v.form.latLang.$error,
                      }"
                    ></b-form-input>
                    <div v-if="$v.form.latLang.$error" class="invalid-feedback">
                      <span v-if="$v.form.latLang.$error">
                        {{ $t('master.address.form.latLong') }}
                        {{ $t('global.validation.required') }}
                      </span>
                    </div>
                  </b-form-group>
                </div>
              </b-col>

              <b-col md="8" sm="12">
                <div class="mb-3">
                  <b-form-group id="radius_label" :label="$t('master.form.address.radius')" label-for="radius">
                    <template v-if="isFormDisabled">
                      <b-form-input
                        id="radius"
                        v-model="form.radius"
                        placeholder="Radius"
                        type="text"
                        :disabled="isFormDisabled"
                      ></b-form-input>
                    </template>
                    <template v-else>
                      <b-form-input
                        id="radius"
                        v-model="form.radius"
                        placeholder="Radius"
                        type="text"
                        :disabled="map_radio == 'polygon'"
                      ></b-form-input>
                    </template>
                  </b-form-group>
                </div>
              </b-col>

              <b-col md="4" sm="12">
                <div class="row mt-4">
                  <span>{{ $t('master.form.address.geofenceType') }}</span>
                  <strong v-if="map_radio == 'circle'">{{
                    $t('master.form.address.circle')
                  }}</strong>
                  <strong v-if="map_radio == 'polygon'">{{
                    $t('master.form.address.polygon')
                  }}</strong>
                </div>
              </b-col>

              <b-col md="12" sm="12" v-if="$store.state.access.data.md1['md1-c1'].read">
                <div class="mb-3 justify-content-center">
                  <b-form-group id="time_label" :label="$t('master.form.address.opsTime')" label-for="time">
                    <div class="row">
                      <div class="col-lg-6">
                        <date-picker
                          class="mc-start-time"
                          v-model="form.serviceStart"
                          format="HH:mm"
                          value-type="format"
                          type="time"
                          placeholder="HH:mm"
                        ></date-picker>
                      </div>
                      <div class="col-lg-6">
                        <date-picker
                          v-model="form.serviceEnd"
                          format="HH:mm"
                          value-type="format"
                          type="time"
                          placeholder="HH:mm"
                        ></date-picker>
                      </div>
                    </div>
                  </b-form-group>
                </div>
              </b-col>

              <b-col md="12" sm="12" v-if="$store.state.access.data.md1['md1-c1'].read">
                <div class="mb-3 justify-content-center">
                  <b-form-group id="time_label" :label="$t('master.form.address.restTime')" label-for="time">
                    <div class="row">
                      <div class="col-lg-6">
                        <date-picker
                          class="mc-start-time"
                          v-model="form.breakStart"
                          format="HH:mm"
                          value-type="format"
                          type="time"
                          placeholder="HH:mm"
                        ></date-picker>
                      </div>
                      <div class="col-lg-6">
                        <date-picker
                          v-model="form.breakEnd"
                          format="HH:mm"
                          value-type="format"
                          type="time"
                          placeholder="HH:mm"
                        ></date-picker>
                      </div>
                    </div>
                  </b-form-group>
                </div>
              </b-col>

              <b-col md="12" sm="12">
                <div class="mb-3">
                  <b-form-group id="address_label" :label="$t('master.form.address.detailInformation')" label-for="address">
                    <b-form-textarea
                      id="address"
                      placeholder="(Cth: Block/Unit No, Patokan)"
                      rows="3"
                      max-rows="6"
                      v-model="form.address_detail"
                      :disabled="isFormDisabled"
                    ></b-form-textarea>
                  </b-form-group>
                </div>
              </b-col>

              <h4 class="card-title mb-4 mt-2">{{ $t('master.form.address.contactInfo') }}</h4>

              <b-col md="6" sm="12">
                <div class="mb-3">
                  <b-form-group
                    id="contact_person_label"
                    :label="$t('master.form.address.contactName')"
                    label-for="contact_person"
                  >
                    <b-form-input
                      id="contact_person"
                      v-model="form.contact_person"
                      :disabled="isFormDisabled"
                      :placeholder="`${$t('global.form.enter')} ${$t('master.form.address.contactName')}`"
                      :class="{
                        'is-invalid': $v.form.contact_person.$error,
                      }"
                    ></b-form-input>
                    <div v-if="$v.form.contact_person.$error" class="invalid-feedback">
                      <span v-if="!$v.form.contact_person.maxLength">{{
                        $t('master.address.form.maxContactName')
                      }}</span>
                    </div>
                  </b-form-group>
                </div>
              </b-col>

              <b-col md="6" sm="12">
                <div class="mb-3">
                  <b-form-group id="radius_label" :label="$t('master.form.address.phoneNo')" label-for="radius">
                    <b-form-input
                      id="radius"
                      v-model="form.phone_no"
                      :disabled="isFormDisabled"
                      :placeholder="`${$t('global.form.enter')} ${$t('master.form.address.phoneNo')}`"
                      :class="{
                        'is-invalid': $v.form.phone_no.$error,
                      }"
                      @keypress="isPhoneNumber($event)"
                      @paste="isPastePhoneNumber($event)"
                      @change="onChangeNumber()"
                    ></b-form-input>
                    <div v-if="$v.form.phone_no.$error" class="invalid-feedback">
                      <span v-if="!$v.form.phone_no.maxLength">{{
                        $t('master.address.form.maxPhoneNumber')
                      }}</span>
                    </div>
                  </b-form-group>
                </div>
              </b-col>

              <h4 class="card-title mb-4 mt-2">{{ $t('global.activity') }}</h4>

              <b-col
                md="12"
                sm="12"
                class="mb-3"
                v-if="
                  $store.state.access.data.md1['md1-c1'].read &&
                  $store.state.masterAddress.status == 'company'
                "
              >
                <div class="p-2 form-control">
                  <div class="d-flex">
                    <b-form-checkbox
                      :value="true"
                      :unchecked-value="false"
                      class="mb-1 mt-1"
                      v-model="form.is_garage"
                      :disabled="isFormDisabled"
                      checked
                      plain
                      >{{ $t('global.garage') }}</b-form-checkbox
                    >
                  </div>
                </div>
              </b-col>

              <b-col
                md="12"
                sm="12"
                class="mb-3"
                v-if="
                  $store.state.access.data.md1['md1-c1'].read &&
                  $store.state.masterAddress.status == 'company'
                "
              >
                <div class="p-2 form-control">
                  <div class="d-flex">
                    <b-form-checkbox
                      :value="true"
                      :disabled="isFormDisabled"
                      :unchecked-value="false"
                      class="mb-1 mt-1"
                      v-model="form.is_service"
                      checked
                      plain
                      v-b-toggle.info-service
                      >{{ $t('master.form.address.serviceLocation') }}</b-form-checkbox
                    >
                  </div>

                  <!-- TODO: Accordion with checkbox little buggy please check -->
                  <b-collapse
                    id="info-service"
                    accordion="my-accordion"
                    role="tabpanel"
                    v-model="form.is_service"
                  >
                    <b-row>
                      <div class="mt-2">
                        <b-form-group id="city_label" label="Tipe Lokasi Servis" label-for="city">
                          <multiselect
                            v-model="form.service_location"
                            placeholder="Tipe Lokasi Servis"
                            :options="['Internal', 'Eksternal']"
                            :disabled="isFormDisabled"
                          ></multiselect>
                        </b-form-group>
                      </div>
                    </b-row>
                  </b-collapse>
                </div>
              </b-col>
              <b-col
                md="12"
                sm="12"
                class="mb-3"
                v-if="$store.state.access.data.md1['md1-c1'].read"
              >
                <div class="p-2 form-control">
                  <div class="d-flex">
                    <b-form-checkbox
                      :value="true"
                      :disabled="isFormDisabled"
                      :unchecked-value="false"
                      class="mb-1 mt-1"
                      v-model="form.is_depot"
                      checked
                      plain
                      >{{ $t('master.form.address.pickupAndSendItem') }}</b-form-checkbox
                    >
                  </div>
                </div>
              </b-col>
              <b-col
                md="12"
                sm="12"
                class="mb-3"
                v-if="
                  $store.state.access.data.md1['md1-c1'].read &&
                  $store.state.masterAddress.status == 'customer'
                "
              >
                <div class="p-2 form-control">
                  <div class="d-flex">
                    <b-form-checkbox
                      :value="true"
                      :disabled="isFormDisabled"
                      :unchecked-value="false"
                      class="mb-1 mt-1"
                      v-model="form.is_billingAddr"
                      checked
                      plain
                      >Invoice</b-form-checkbox
                    >
                  </div>
                </div>
              </b-col>
              <b-col
                md="12"
                sm="12"
                class="mb-3"
                v-if="!$store.state.access.data.md1['md1-c1'].read"
              >
                <div class="p-2 form-control">
                  <div class="d-flex">
                    <b-form-checkbox
                      :value="true"
                      :disabled="isFormDisabled"
                      :unchecked-value="false"
                      class="mb-1 mt-1"
                      v-model="form.is_garage"
                      checked
                      plain
                      >{{ $t('global.garage') }}</b-form-checkbox
                    >
                  </div>
                </div>
              </b-col>

              <b-col
                md="12"
                sm="12"
                class="mb-3"
                v-if="!$store.state.access.data.md1['md1-c1'].read"
              >
                <div class="p-2 form-control">
                  <div class="d-flex">
                    <b-form-checkbox
                      :value="true"
                      :disabled="isFormDisabled"
                      :unchecked-value="false"
                      class="mb-1 mt-1"
                      v-model="form.is_service"
                      checked
                      plain
                      v-b-toggle.info-service
                      >{{ $t('master.address.form.serviceLocation') }}</b-form-checkbox
                    >
                  </div>

                  <!-- TODO: Accordion with checkbox little buggy please check -->
                  <b-collapse
                    id="info-service"
                    accordion="my-accordion"
                    role="tabpanel"
                    v-model="form.is_service"
                  >
                    <b-row>
                      <div class="mt-2">
                        <b-form-group id="city_label" label="Tipe Lokasi Servis" label-for="city">
                          <multiselect
                            v-model="form.service_location"
                            placeholder="Tipe Lokasi Servis"
                            :options="['Internal', 'Eksternal']"
                            :disabled="isFormDisabled"
                          ></multiselect>
                        </b-form-group>
                      </div>
                    </b-row>
                  </b-collapse>
                </div>
              </b-col>
            </b-row>
          </b-card>
        </b-col>
      </b-row>
    </form>

    <!-- Modal for Update Confirmation -->
    <b-modal
      class="mc-modal"
      id="modal-change-data"
      title="Hapus"
      size="md"
      centered
      scrollable
      @ok="toSave"
    >
      <div class="card-body mc-modal__filter p-2">
        <p>
          {{ $t('master.address.form.alreadyUsed') }}
        </p>
      </div>
      <template #modal-footer="{ cancel }">
        <b-row class="mc-modal__filter-footer mx-0">
          <b-col sm="12" md="12" class="mc-modal__filter-footer-btn">
            <b-button variant="outline-primary" @click="cancel()" class="me-2">
              {{ $t('global.no') }}
            </b-button>
            <b-button @click="toSave" variant="primary"> {{ $t('global.yes') }} </b-button>
          </b-col>
        </b-row>
      </template>
    </b-modal>
  </Layout>
</template>
